import { action } from 'satcheljs';
export var manageDomainClick = action('manageDomainClick');
//# sourceMappingURL=manageDomainClick.js.map